// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveLowerEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

export const notificationChannelSchema = caseInsensitiveLowerEnum(['email']);

export const NOTIFICATION_CHANNELS = notificationChannelSchema.options;

export type NotificationChannel = z.infer<typeof notificationChannelSchema>;

const NOTIFICATION_CHANNEL_LABELS: Record<NotificationChannel, string> = {
  email: 'email',
};

/**
 * A convenience function that returns the label for a given notification
 * channel.
 *
 * @param channel - The notification channel.
 */
export function getNotificationChannelLabel(
  channel: NotificationChannel
): string {
  return NOTIFICATION_CHANNEL_LABELS[channel];
}
